import button from './button';
import checkbox from './checkbox';
import datatable from './datatable';
import dialog from './dialog';
import dropdown from './dropdown';
import inputtext from './inputtext';
import toast from './toast';
import tooltip from './tooltip';

export const theme = {
  checkbox,
  datatable,
  directives: {
    tooltip,
  },
  toast,
  dropdown,
  inputtext,
  button,
  dialog,
};
